import { CloseOutlined } from "@mui/icons-material";
import { Button } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { enUS } from "date-fns/esm/locale";
import { memo, useMemo } from "react";

import { isValidDate } from "../../../../../ui library/helpers/dates";
import { normalizeValue } from "../../../utils/functions";

const DEFAULT_DATE_PICKER_SLOT_PROPS = { textField: { variant: "outlined" } };

const DatePickerFilter = ({
  currentValue,
  datePickerSlotProps = DEFAULT_DATE_PICKER_SLOT_PROPS,
  fieldName,
  title,
  updateFilter,
}) => {
  const normalizedValue = useMemo(() => normalizeValue(currentValue || new Date()), [currentValue]);

  const handleOnDateChange = (newValue) => {
    if (!!newValue && !isValidDate(newValue)) {
      return;
    }
    const newDate = !newValue ? null : new Date(newValue).toISOString().slice(0, 10);
    updateFilter(fieldName, newDate);
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={enUS}>
      <DatePicker
        format="MM/dd/yyyy"
        className="w-full my-1 mr-1 text-center"
        label={title}
        value={normalizedValue}
        onChange={(newValue) => handleOnDateChange(newValue)}
        slotProps={datePickerSlotProps}
      />

      {currentValue && (
        <Button
          variant="text"
          onClick={() => handleOnDateChange(null)}
          className="p-0 text-sm text-red-600 w-fit hover:bg-transparent hover:text-red-400"
        >
          <CloseOutlined />
        </Button>
      )}
    </LocalizationProvider>
  );
};

export default memo(DatePickerFilter);
